import React, { useState, Suspense } from "react"
import { Outlet } from "react-router-dom"
import { Box, Stack } from "@mui/material"
import { ProfessorHeaderView as Header } from "components/Header/ProfessorHeader.view"
import { ProfessorSidebarView as SidebarDrawer } from "components/SidebarDrawer/ProfessorSidebar.view"
import Loading from "components/Loading"
import { styles } from "./ProfessorLayout.styles"
import { GamesRouteProviders } from "routers/GamesRouteProviders"

export const ProfessorLayoutUI = ({ showHeader = true }) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  return (
    <Box>
      <SidebarDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <Stack component="main" sx={styles.main(showHeader)}>
        {showHeader && <Header onMenuClick={() => setDrawerOpen(true)} />}
        <Suspense fallback={<Loading />}>
          <GamesRouteProviders>
            <Outlet />
          </GamesRouteProviders>
        </Suspense>
      </Stack>
    </Box>
  )
}
